import {
  isPageReferenceActivity,
  isPageReferenceStep,
  PageReferenceActivity,
  PageReferenceActivityGroup,
} from '@gkn-ili/views/dist/OrderDocumentation';
import { RoutingItemView, PageReference, PageReferenceStep } from '@gkn-ili/views/src/OrderDocumentation';

export function getPageOrderInRoutingItem(order: RoutingItemView, routingItemKey: string): PageReference[] {
  const references: PageReference[] = [];

  for (const stepKey in order.steps) {
    if (Object.prototype.hasOwnProperty.call(order.steps, stepKey)) {
      const step = order.steps[stepKey];
      references.push({ routingItemKey, stepKey });

      for (const activityGroupKey in step.activityGroups) {
        if (Object.prototype.hasOwnProperty.call(step.activityGroups, activityGroupKey)) {
          const activityGroup = step.activityGroups[activityGroupKey];
          references.push({ routingItemKey, stepKey, activityGroupKey });

          for (const activityKey in activityGroup.activities) {
            if (Object.prototype.hasOwnProperty.call(activityGroup.activities, activityKey)) {
              references.push({ routingItemKey, stepKey, activityGroupKey, activityKey });
            }
          }
        }
      }
    }
  }

  return references;
}

export function getPageType(activePage: PageReference) {
  if (isPageReferenceActivity(activePage)) {
    return 'activity';
  }
  if (isPageReferenceStep(activePage)) {
    return 'step';
  }
  return 'activityGroup';
}

export const pageTypeNationales: Record<ReturnType<typeof getPageType>, string> = {
  activity: 'activity',
  activityGroup: 'activity group',
  step: 'step',
};

export function pageReferenceIsEqual(a: PageReference, b: PageReference) {
  if (a.routingItemKey !== b.routingItemKey) {
    return false;
  }
  if (a.stepKey !== b.stepKey) {
    return false;
  }
  if ((a as PageReferenceActivityGroup).activityGroupKey !== (b as PageReferenceActivityGroup).activityGroupKey) {
    return false;
  }
  if ((a as PageReferenceActivity).activityKey !== (b as PageReferenceActivity).activityKey) {
    return false;
  }

  return true;
}
export function getParentPageReference(a: PageReferenceActivity): PageReferenceActivityGroup;
export function getParentPageReference(a: PageReferenceActivityGroup): PageReferenceStep;
export function getParentPageReference(a: PageReference): PageReference {
  if (isPageReferenceActivity(a)) {
    return {
      routingItemKey: a.routingItemKey,
      stepKey: a.stepKey,
      activityGroupKey: a.activityGroupKey,
    };
  }
  return {
    routingItemKey: a.routingItemKey,
    stepKey: a.stepKey,
  };
}
